// A bidi override (U+202A-U+202E, U+2066-U+2069) can make "invoice.pdf.exe" read as
// "invoice.exe.pdf", and a zero-width character (U+200B-U+200D, U+FEFF) can make two
// visually-identical names collide or hide a payload - neither belongs in a rendered name.
const FORBIDDEN_NAME_CHARS = /[\u200B-\u200D\uFEFF\u202A-\u202E\u2066-\u2069]/;

export function isSafeName(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && !FORBIDDEN_NAME_CHARS.test(value);
}

export const SAFE_NAME_MESSAGE =
  'must not be empty, whitespace-only, or contain a bidi-override or zero-width character';
